'use strict';

/*global services*/
/*global initialize*/
function Parameters() {

  this.init();
}

Parameters.prototype = $.extend({}, {
  constructor: 'Parameters',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.view-parameters', function () {
      _this.viewParameters($(this).data('batch_id'));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  viewParameters: function viewParameters(batchId) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('parameters.title'),
      height: 'auto',
      width: 'lg',
      minHeight: '300px',
      modalClass: 'parameters-form',
      form: false,
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('parameters_detail', { batchId: batchId }), function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        initialize(modal.contentDOM());
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
